import {
    SET_LOADING,
    TRIP_CHANGE,
    UPDATE_PLACE,
    DELETE_PLACE,
    INSERT_PLACE,
    UPDATE_MONEY,
    DELETE_MONEY,
    INSERT_MONEY,
    SET_LOADING_2,
} from './constants';

export const setLoading = (payload) => ({
    type: SET_LOADING,
    payload,
});

export const setLoading2 = (payload) => ({
    type: SET_LOADING_2,
    payload,
});

export const tripChange = (payload) => ({
    type: TRIP_CHANGE,
    payload,
});

export const updatePlace = (payload) => ({
    type: UPDATE_PLACE,
    payload,
});

export const deletePlace = (payload) => ({
    type: DELETE_PLACE,
    payload,
});

export const insertPlace = (payload) => ({
    type: INSERT_PLACE,
    payload,
});

export const updateMoney = (payload) => ({
    type: UPDATE_MONEY,
    payload,
});

export const deleteMoney = (payload) => ({
    type: DELETE_MONEY,
    payload,
});

export const insertMoney = (payload) => ({
    type: INSERT_MONEY,
    payload,
});
